import React from 'react';
import { useI18n } from '@/i18n/I18nContext';
import { WHY } from '@/constants/testIds';

const WHY_BG =
  'https://images.unsplash.com/photo-1605745341112-85968b19335b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxjb250YWluZXIlMjBzaGlwJTIwb2NlYW58ZW58MHx8fHwxNzgwOTAzNzQyfDA&ixlib=rb-4.1.0&q=85&w=2000&h=1200';

export const WhyChooseUs = () => {
  const { t } = useI18n();
  const items = t('why.items') || [];
  const stats = t('why.stats') || [];

  return (
    <section id="why" data-testid={WHY.root} className="relative py-24 sm:py-32 overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 -z-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${WHY_BG})` }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 -z-10 bg-[#050D17]/92" aria-hidden="true" />

      <div className="container mx-auto px-6">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#C9A24E]" />
            <span className="text-[11px] uppercase tracking-[0.32em] text-[#C9A24E]">
              {t('why.eyebrow')}
            </span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F2F5F8] leading-[1.1]">
            {t('why.title')}
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
          {items.map((item, idx) => (
            <div key={item.title} className="flex gap-5">
              <div className="font-serif text-[#C9A24E] text-2xl leading-none pt-1 w-10 shrink-0">
                {String(idx + 1).padStart(2, '0')}
              </div>
              <div className="flex-1 border-t border-[#C9A24E]/20 pt-4">
                <h3 className="font-serif text-xl text-[#F2F5F8] mb-2">{item.title}</h3>
                <p className="text-sm text-[#C9D2E2] leading-relaxed">{item.body}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Stats strip */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 border border-[#C9A24E]/20 bg-[#0A1A2F]/60 backdrop-blur-sm">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`px-6 py-8 text-center ${
                i < stats.length - 1 ? 'md:border-r border-[#C9A24E]/15' : ''
              } ${i < 2 ? 'border-b md:border-b-0 border-[#C9A24E]/15' : ''} ${
                i === 0 ? 'border-r' : ''
              } ${i === 2 ? 'border-r md:border-r' : ''}`}
            >
              <div className="font-serif text-3xl sm:text-4xl text-[#C9A24E]">{s.value}</div>
              <div className="mt-2 text-[10px] uppercase tracking-[0.28em] text-[#8F9BB3]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
